<!-- <p>Under Construction</p> -->

<div *ngIf="showSI">
    
    <!-- <ngx-extended-pdf-viewer [src]="'assets/helpFiles/EFS_Special_Ins_Userguide.pdf'" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer> -->
    <iframe src="assets/Basic_Template/EFS_Special_Ins_Userguide.pdf" width="100%" height="600px" style="border: none;"></iframe>

</div>

<div *ngIf="showSetupHelp">
    <h4>Hover over the name of the page you'd like to navigate to and click.</h4>
    <h4>You may also navigate using the Navigation panel on the upper left at any time.</h4>
</div>

<div *ngIf="showPH">
    
    <iframe src="assets/Basic_Template/EFS_Prehold_Temp_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showPM">
    
    <iframe src="assets/Basic_Template/EFS_ProductionMethod_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showPT">
    
    <iframe src="assets/Basic_Template/EFS_Plan_Temp_userguide_7_9_2025.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showPS">
    
    <iframe src="assets/Basic_Template/EFS_Production_Temp_userguide_2_27_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showCS">
    
    <iframe src="assets/Basic_Template/EFS_Corp_setup_userguide.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showRA">
    
    <iframe src="assets/Basic_Template/RoleAdministrationUserGuideV1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for package template -->
<div *ngIf="showPK">
    
    <iframe src="assets/Basic_Template/EFS_Production_Temp_userguide_2_27_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for rule setup -->
<div *ngIf="showRS">
    
    <iframe src="assets/Basic_Template/EFS_Rule_setup_userguide_4_17_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for national corp setup -->
<div *ngIf="showNCS">
    
    <iframe src="assets/Basic_Template/NationalCorpSetupUserGuide.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for national dispatch template -->
<div *ngIf="showNDT">
    
    <iframe src="assets/Basic_Template/EFS_National_Dispatch_Template_Setup_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for client summary -->
<div *ngIf="showCLS">
    
    <iframe src="assets/Basic_Template/EFS_Client_Summary_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for single user setup icc -->
<div *ngIf="showSUSICC">
    
    <iframe src="assets/Basic_Template/SingleUserSetupHelpScreenDocument.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>
<!-- Help page for A&R -->
<div *ngIf="showAR">
    
    <iframe src="assets/Basic_Template/EFS_A&R_UserGuide_8_4_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>
<!-- Help page for Bill of Material Setup -->
<div *ngIf="showBOM">
    
    <iframe src="assets/Basic_Template/EFS_BOM_UserGuide_9_24_2026_resized.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- test 3-->